export class Identifier<T> {
  private readonly _value: T;

  public constructor(value: T) {
    this._value = value;
  }

  public equals(id?: Identifier<T>): boolean {
    if (id === null || id === undefined) {
      return false;
    }
    if (!(id instanceof this.constructor)) {
      return false;
    }
    return id.toValue() === this._value;
  }

  public toString(): string {
    return String(this._value);
  }

  /**
   * Return raw value of identifier
   */

  public toValue(): T {
    return this._value;
  }
}
